import { useQueryClient } from 'react-query';

export const useInvalidateFaxTemplatesList = () => {
  const queryClient = useQueryClient();
  return () => {
    const keys = ['list-coversheet-template'];
    queryClient.invalidateQueries(keys);
  };
};
